// Logo for header only
export const rmzLogo = "https://firebasestorage.googleapis.com/v0/b/rmz-ai-4d647.firebasestorage.app/o/Rmz.ai_resources%2Frmz.ai%20logo-04.png?alt=media&token=5239cc12-5abd-4fee-8f1d-9e94375e95a1";

// Logo for other pages
export const rmzLogoFull = "https://firebasestorage.googleapis.com/v0/b/rmz-ai-4d647.firebasestorage.app/o/Rmz.ai_resources%2Frmz.ai%20logo-01.png?alt=media&token=5dee8462-fcd0-433a-bb0c-10ae8d807c96";